import React from 'react'
import { faQrcode } from '@fortawesome/free-solid-svg-icons'

import QbHeading from '../shared/QbHeading/QbHeading'
import QbDisplay from '../shared/QbDisplay/QbDisplay'
import QbButton from '../shared/QbButton/QbButton'
import QbQrCode from '../shared/QbQrCode/QbQrCode'
import { mergeToNewObject } from '../../util/helpers'
import './ReceiveWallet.css'
import WebMenuHolder from '../shared/WebMenu/WebMenuHolder'

const ReceiveWallet = ({
  t,
  walletAddress,
  handleShowQr,
  showQr,
  copyAddress,
  copySuccessMsg  
}) => {
  function renderQr() {
    return (
      <div className="receive-wallet-qr-content">
        <QbQrCode
          value={walletAddress}
          size={190}
        />
        <div style={{marginTop: '30px'}}>
          <QbButton style={STYLE.QR_CANCEL} simple name={t('button-actions.cancel')} onClick={handleShowQr} />
        </div>
        
      </div>
    ) 
  }

  function renderAddress() {
    return (
      <div className="receive-wallet-content">
        <QbDisplay
          value={walletAddress}
          contentStyle={mergeToNewObject(STYLE.DISPLAY_CONTENT, copySuccessMsg ? {borderColor: 'var(--qb-primary-color-one)'} : {})}
        />
        <div className="qb-input-success-msg">{t(copySuccessMsg)}</div>
        <div className="receive-wallet-actions">
          <QbButton
            simple
            icon={faQrcode}
            iconStyle={STYLE.QR_ICON}
            name={t('wallet.receive.view-code')}
            style={STYLE.QR_BUTTON}
            onClick={handleShowQr}
          />
          <QbButton
            name={t('wallet.receive.copy-address')}
            onClick={copyAddress}      
          />
        </div>
      </div>
    )
  }
  return (
    <div className="main-content-container">
      <WebMenuHolder title={t('wallet.main-title')} />
      
      <div className="main-content-body">
        <QbHeading title={t('wallet.receive.headline')} text={t('wallet.receive.message')} />
        { showQr ? renderQr() : renderAddress() }
      </div>
    </div>
  )
}

export default ReceiveWallet

const STYLE = {
  QR_BUTTON: {
    color: 'var(--qb-gray-color)'
  },
  QR_ICON: {
    width: '16px',
    height: '18px'
  },
  QR_CANCEL: {
    color: 'var(--qb-gray-color)'
  },
  DISPLAY_CONTENT: {
    height: 'auto',
    fontWeight: 600
  },
}



// WEBPACK FOOTER //
// ./src/components/ReceiveWallet/ReceiveWallet.js